import { RightOutlined } from '@ant-design/icons';
import Ribbon from 'assets/ribbon.svg?react';
import ModuleCard from 'components/cards/ModuleCard';
import posthog from 'posthog-js';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { routes } from 'services/RouteService';

type OctobreRoseCardProps = {
  /** Page the card is displayed on, for analytics and test ids. */
  openedOnPage: 'home' | 'info';
};

export default function OctobreRoseCard({ openedOnPage }: OctobreRoseCardProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const navigateToOctobreRose = () => {
    posthog.capture(`${openedOnPage}.octobre_rose_clicked`);
    navigate(routes.octobreRose.route);
  };
  const handleKeyDown = (e: React.KeyboardEvent) => e.key === 'Enter' && navigateToOctobreRose();

  return (
    <ModuleCard
      style={{ background: 'var(--gradient-highlight)' }}
      onClick={navigateToOctobreRose}
      role="button"
      tabIndex={0}
      onKeyDown={handleKeyDown}
    >
      <div className="text-foreground flex items-center gap-3.5" data-testid={`${openedOnPage}-octobre-rose-card`}>
        <div className="flex size-11 shrink-0 items-center justify-center rounded-full bg-white/35 text-xl">
          <Ribbon aria-hidden="true" width={32} height={32} />
        </div>
        <div className="min-w-0 flex-1">
          <p className="m-0 text-base leading-snug font-bold">{t('home.octobreRose.title')}</p>
          <p className="mt-0.5 mb-0 text-xs leading-snug">
            {t('home.octobreRose.subtitle')}
            {/* A non-breaking space, so the caret can't wrap onto a line of its own — it stays glued to the last word. */}{' '}
            <RightOutlined className="text-sm" />
          </p>
        </div>
      </div>
    </ModuleCard>
  );
}
